import { Box } from '@mui/material';
import MaintainenceInspectionSites from './MaintainenceInspectionSites';

const MaintainenceInspectionHome = () => {
  return (
    <>
      <Box className={"h-100 w-100"}>
        <Box className={"h-100 w-100"}>
          <MaintainenceInspectionSites />
        </Box>
      </Box>
    </>
  );
};

export default MaintainenceInspectionHome;
